<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="设备ID" prop="deviceId" >
        <a-input v-model="form.deviceId" placeholder="请输入设备ID" />
      </a-form-model-item>
      <a-form-model-item label="地暖开关：1开 0关" prop="switchOn" >
        <a-input v-model="form.switchOn" placeholder="请输入地暖开关：1开 0关" />
      </a-form-model-item>
      <a-form-model-item label="当前地暖温度(℃)" prop="currentTemp" >
        <a-input v-model="form.currentTemp" placeholder="请输入当前地暖温度(℃)" />
      </a-form-model-item>
      <a-form-model-item label="预设温度(℃)" prop="presetTemp" >
        <a-input v-model="form.presetTemp" placeholder="请输入预设温度(℃)" />
      </a-form-model-item>
      <a-form-model-item label="定时开关：1开 0关" prop="timerEnabled" >
        <a-input v-model="form.timerEnabled" placeholder="请输入定时开关：1开 0关" />
      </a-form-model-item>
      <a-form-model-item label="定时开始时间" prop="timerStartTime" >
        <a-date-picker style="width: 100%" v-model="form.timerStartTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="定时结束时间" prop="timerEndTime" >
        <a-date-picker style="width: 100%" v-model="form.timerEndTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getHeatingSetting, addHeatingSetting, updateHeatingSetting } from '@/api/mibo/heatingSetting'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        deviceId: null,

        switchOn: null,

        currentTemp: null,

        presetTemp: null,

        timerEnabled: null,

        timerStartTime: null,

        timerEndTime: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        deviceId: [
          { required: true, message: '设备ID不能为空', trigger: 'blur' }
        ],
        switchOn: [
          { required: true, message: '地暖开关：1开 0关不能为空', trigger: 'blur' }
        ],
        currentTemp: [
          { required: true, message: '当前地暖温度(℃)不能为空', trigger: 'blur' }
        ],
        presetTemp: [
          { required: true, message: '预设温度(℃)不能为空', trigger: 'blur' }
        ],
        timerEnabled: [
          { required: true, message: '定时开关：1开 0关不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        deviceId: null,
        switchOn: null,
        currentTemp: null,
        presetTemp: null,
        timerEnabled: null,
        timerStartTime: null,
        timerEndTime: null,
        createTime: null,
        remark: null,
      }
                                  },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getHeatingSetting({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateHeatingSetting(this.form).then(response => {

              if(response.success) {
                this.$message.success('修改成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '修改失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addHeatingSetting(this.form).then(response => {
              if(response.success) {
                this.$message.success('新增成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '新增失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
